var stack = [];
var captureGroup;

export function startCapturing () {
	stack.push( captureGroup = [] );
}

export function stopCapturing () {
	var dependencies = stack.pop();
	captureGroup = stack[ stack.length - 1 ];
	return dependencies;
}

export function capture ( model ) {
	if ( captureGroup ) {
		captureGroup.push( model );
	}
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/global/capture.js.map
